import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import logo from "../assets/images/logo2.png";
import EmailIcon from "@mui/icons-material/Email";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState, useEffect } from "react";
import ERPSnakBar from "../components/ERPSnakBar";
import { LoginType } from "../customTypes/customTypes";
import { userLogin } from "../services/loginService";
import { useNavigate } from "react-router-dom";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoginIn, setIsLogin] = useState(true);
  const navigate = useNavigate();
  const [login, setLoign] = useState<LoginType>({
    email: "",
    password: "",
  });
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    serverity: "",
  });

  const handleLogin = async () => {
    try {
      const res: any = await userLogin(login);
      console.log(res, "response");
      if (res.status) {
        localStorage.setItem("user", JSON.stringify(res.data));
      }
      navigate("/", { replace: true });
    } catch (error: any) {
      console.log(error);
      setAlert({
        open: true,
        message: error.response ? error.response.data.msg : error.message,
        serverity: "error",
      });
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      navigate("/", { replace: true });
    } else {
      setIsLogin(false);
    }
  });

  return (
    <>
      {isLoginIn ? null : (
        <Box
          sx={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            width={{ xs: 300, sm: 400 }}
            height={{ xs: 420, sm: 450 }}
            component={Paper}
            elevation={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              px: { xs: 4, sm: 6 },
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                mt: 5,
                fontWeight: 600,
                letterSpacing: 1,
              }}
              variant="h6"
              gutterBottom
            >
              Welcome
            </Typography>
            <Box
              sx={{
                mt: 1,
                borderRadius: "50%",
                border: 1,
                p: 0.5,
                borderColor: "rgba(0, 0, 0, 0.06)",
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
              }}
            >
              <img src={logo} alt="logo" style={{ width: 60, height: 55 }} />
            </Box>
            <Box
              component={"div"}
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                mt: { xs: 1, sm: 3 },
                gap: 1,
              }}
            >
              <TextField
                name="email"
                variant="standard"
                label="E-Mail"
                fullWidth
                value={login.email}
                onChange={(e) => setLoign({ ...login, email: e.target.value })}
                sx={{
                  "& .MuiInputBase-root": {
                    ":hover": {
                      "&:before": {
                        borderColor: "primary.main",
                      },
                    },
                  },
                }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <EmailIcon
                        sx={{ color: "primary.main", fontSize: 18, mr: 1 }}
                      />
                    ),
                  },
                }}
              />
              <TextField
                name="password"
                variant="standard"
                label="Password"
                fullWidth
                value={login.password}
                onChange={(e) =>
                  setLoign({ ...login, password: e.target.value })
                }
                sx={{
                  "& .MuiInputBase-root": {
                    ":hover": {
                      "&:before": {
                        borderColor: "primary.main",
                      },
                    },
                  },
                }}
                slotProps={{
                  input: {
                    type: showPassword ? "text" : "password",

                    endAdornment: (
                      <Box
                        component={"div"}
                        onMouseEnter={() => setShowPassword(true)}
                        onMouseLeave={() => setShowPassword(false)}
                        sx={{
                          cursor: "pointer",
                        }}
                      >
                        {showPassword ? (
                          <VisibilityIcon
                            sx={{
                              color: "primary.main",
                              fontSize: 18,
                              mr: 1,
                            }}
                          />
                        ) : (
                          <VisibilityOffIcon
                            sx={{
                              color: "primary.main",
                              fontSize: 18,
                              mr: 1,
                            }}
                          />
                        )}
                      </Box>
                    ),
                  },
                }}
              />
              <Button
                sx={{ mt: 4, width: "100%" }}
                variant="contained"
                onClick={handleLogin}
              >
                Login
              </Button>
              <Typography
                component={"a"}
                textAlign={"center"}
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  letterSpacing: 1,
                  mt: { xs: 3, sm: 4 },
                  color: "rgba(0, 0, 0, 0.6)",
                  cursor: "pointer",
                  "&:hover": {
                    color: "primary.main",
                  },
                }}
              >
                forgot password ?
              </Typography>
            </Box>
          </Box>
          <ERPSnakBar
            open={alert.open}
            onClose={() =>
              setAlert({ open: false, message: "", serverity: "" })
            }
            serverity={alert.serverity}
            message={alert.message}
          />
        </Box>
      )}
    </>
  );
}

export default Login;
